import React from 'react';
import './navbar.css';
import { Link } from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

const Navbar = () => {
    return(
        <nav className='navbar'>
            {/* <img src={AK} alt="Logo" className='logo' /> */}
            <div className="desktopMenu">
                <Link activeClass='active'  to='Header'  spy={true} smooth={true} offset={-100} duration={500} className='desktopMenuListItem'>Home</Link>
                <Link activeClass='active'  to='skills'  spy={true} smooth={true} offset={-50} duration={500}  className='desktopMenuListItem'>About</Link>
                <Link activeClass='active'  to='works'  spy={true} smooth={true} offset={-50} duration={500}  className='desktopMenuListItem'>Protfolio</Link>


            </div>
            <button className="desktopMenuBtn" onClick={()=>{
document.getElementById('contact').scrollIntoView({behavior:'smooth'});
            }
            }>
            <FontAwesomeIcon icon={faUser}/>
             Contact Me
</button>
        </nav>
    )
}
export default Navbar;